import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { Conversion, ConversionReqBody } from '../../../types/conversion';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useConversionActions = (whichAction: 'conversionList' | '') => {
  // query function to fetch points to minute conversion list from database declared here
  const getMinuteConversionListHandler = useQuery({
    queryKey: ['conversion-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Conversion>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        '/point/to/minute/conversion/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'conversionList'),
  });

  // mutation function to create new conversion into the database declared here
  const createNewConversionHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: ConversionReqBody;
    }): Promise<AcademiaResponse<Conversion>> => {
      const response = await getPrivateAxiosInstance('appointment').post(
        '/point/to/minute/conversion/create/',
        body
      );

      return response.data;
    },
  });

  const updateConversionHandler = useMutation({
    mutationFn: async ({
      conversionId,
      body,
    }: {
      conversionId: number;
      body: ConversionReqBody;
    }): Promise<AcademiaResponse<Conversion>> => {
      const response = await getPrivateAxiosInstance('appointment').patch(
        `/point/to/minute/conversion/${conversionId}/partial/update/`,
        body
      );

      return response.data;
    },
  });

  const deleteConversionByIdHandler = useMutation({
    mutationFn: ({
      conversionId,
    }: {
      conversionId: number;
    }): Promise<AxiosResponse<AcademiaResponse<null>>> =>
      getPrivateAxiosInstance('appointment').delete(
        `/point/to/minute/conversion/${conversionId}/delete/`
      ),
  });

  return {
    getMinuteConversionListHandler,
    createNewConversionHandler,
    updateConversionHandler,
    deleteConversionByIdHandler,
  };
};

export default useConversionActions;
